var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNavigationManual = function SvgNavigationManual(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16797 1.83301C4.16797 1.28072 4.61568 0.833008 5.16797 0.833008H24.8346C25.3869 0.833008 25.8346 1.28072 25.8346 1.83301V24.833C25.8346 25.3853 25.3869 25.833 24.8346 25.833H5.16797C4.61568 25.833 4.16797 25.3853 4.16797 24.833V1.83301ZM20.9659 7.15986C20.81 7.00346 20.576 6.95752 20.372 7.04009L8.34069 11.962C8.11592 12.0544 7.97865 12.2835 8.00436 12.5253C8.02951 12.767 8.21108 12.9628 8.45008 13.0065L14.0933 14.0324L15.1198 19.6757C15.163 19.9146 15.3588 20.0962 15.6005 20.1219C15.6197 20.1235 15.6388 20.1246 15.6574 20.1246C15.8772 20.1246 16.079 19.9918 16.1638 19.7845L21.0857 7.75322C21.1688 7.54976 21.1217 7.31572 20.9659 7.15986ZM7.5013 28.1663V27.4997H26.5013C27.0536 27.4997 27.5013 27.052 27.5013 26.4997V3.33301H28.168C28.7203 3.33301 29.168 3.78072 29.168 4.33301V28.1663C29.168 28.7186 28.7203 29.1663 28.168 29.1663H8.5013C7.94902 29.1663 7.5013 28.7186 7.5013 28.1663Z",
    fill: "#0073BF",
    className: "fill"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavigationManual, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navigation-manual.ac2e0bfe.svg";
export { ForwardRef as ReactComponent };